module.exports = global["surveylab_page_number"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./number.ts");